import React, { useEffect } from "react";
import { useLoader } from "../context/LoaderContext";
import CommingSoon from "../components/CommingSoon";
import FellowshipBanner from "../components/academics/FellowshipBanner";

const FellowShip = () => {
  const { setLoading } = useLoader();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [setLoading]);
  return (
    <>
        <FellowshipBanner/>
        <CommingSoon/>
    </>
  )
};

export default FellowShip;
